"use strict";

const { Duration } = require("luxon");

const isStartOfSnapUnit = require("../utils/is-start-of-snap-unit");

const isSnapUnitLongerThanDuration = (props) => {
  const { dateDuration, snapDates } = props;
  const duration = Duration.fromISO(dateDuration);
  const snapUnit = Duration.fromObject({
    [`${snapDates}s`]: 1
  });

  return snapUnit > duration;
};

/**
 * Snap dates back to snapDates time-unit.
 */
const getSnappedStartDate = (result, props) => {
  const { startDate, endDate } = result;
  const { mode, snapDates } = props;

  if (!snapDates) {
    return result;
  }

  // If there is a dateDuration, snap forwards by 1 snap-unit when end-date is a partial snap-unit
  // (bypass if the snap-unit is longer than the duration, to avoid having a start-date more recent than an end-date)
  if (
    mode === "rolling" &&
    !isStartOfSnapUnit(endDate, snapDates) &&
    !isSnapUnitLongerThanDuration(props)
  ) {
    return {
      ...result,
      startDate: startDate
        .plus({
          [`${snapDates}s`]: 1
        })
        .startOf(snapDates)
    };
  }

  return {
    ...result,
    startDate: startDate.startOf(snapDates)
  };
};

module.exports = getSnappedStartDate;
